// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"104":"dda38fa1","178":"6fe99b91","327":"d9b4e908","530":"9e2556f2","631":"38229a78","680":"7fea4bea","927":"982e2532"}[chunkId] + ".chunk.js";
};